module.exports = __webpack_public_path__ + "img/53.3990dc83.jpg";